import { Carousel } from 'antd';
import { useAppSelector } from '@/AppRedux/store/hooks';
import HotelProfileStateHook from '@/hooks/useHotelProfileState';

const SLIDE_HEIGHT = 360;

export default function HotelHeroCarousel() {
  const { dataSource } = HotelProfileStateHook()
  const galleryMode = useAppSelector((state) => state.hotelProfile.hotelSettings?.gallery_mode)
  const { hotelCarousel = [] } = dataSource || {}

  const modeVisible = !galleryMode || galleryMode === 'slide' || galleryMode === 'both'
  const displayCarousel = modeVisible && hotelCarousel && hotelCarousel.length > 0

  return (
    <div style={{ borderRadius: 16, overflow: 'hidden', display: displayCarousel ? 'block' : 'none' }}>
      <Carousel
        autoplay
        dots
        arrows={hotelCarousel.length > 1}
      >
        {hotelCarousel.map((src: string, idx: number) => (
          <div key={idx}>
            <div style={{ position: 'relative', height: SLIDE_HEIGHT, overflow: 'hidden', background: '#000' }}>
              <img
                src={src}
                aria-hidden
                style={{
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  filter: 'blur(20px) brightness(0.45)',
                  transform: 'scale(1.12)',
                }}
              />
              <img
                src={src}
                alt={`slide-${idx}`}
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  display: 'block',
                }}
              />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}
